export default __webpack_public_path__ + "static/media/MurghiMandi.0be74d87.png";